import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared.module';
import { AuxDialogComponent } from './aux-dialog.component';


@NgModule({
  imports: [
    SharedModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [AuxDialogComponent]
})
export class AuxDialogModule {}
